import { useGetRegistrations } from "../../../api/insights";
import { StageFunnel } from "../charts";
import SectionShell from "../SectionShell";

function InviteFunnel({ eventId }) {
  const { data, isPending, isError, error } = useGetRegistrations(eventId);
  const invites = data?.invitePerformance;

  const stages = [
    { key: "sent", label: "Sent", value: invites?.sent },
    { key: "delivered", label: "Delivered", value: invites?.delivered },
    { key: "opened", label: "Opened", value: invites?.opened },
    { key: "registered", label: "Registered", value: invites?.registered },
    {
      key: "ticketsIssued",
      label: "Tickets issued",
      value: invites?.ticketsIssued,
    },
  ];

  return (
    <SectionShell
      id="inviteFunnel"
      title="Invite funnel"
      description="How invite emails converted into tickets."
      isPending={isPending}
      isError={isError}
      error={error}
      eventId={eventId}
      analysisKey="inviteFunnel"
    >
      <StageFunnel stages={stages} />
    </SectionShell>
  );
}

export default InviteFunnel;
